"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.settingDots = void 0;
exports.settingDots = {
    path: "M5.00001 8.33333C4.08334 8.33333 3.33334 9.08333 3.33334 9.99999C3.33334 10.9167 4.08334 11.6667 5.00001 11.6667C5.91668 11.6667 6.66668 10.9167 6.66668 9.99999C6.66668 9.08333 5.91668 8.33333 5.00001 8.33333ZM15 8.33333C14.0833 8.33333 13.3333 9.08333 13.3333 9.99999C13.3333 10.9167 14.0833 11.6667 15 11.6667C15.9167 11.6667 16.6667 10.9167 16.6667 9.99999C16.6667 9.08333 15.9167 8.33333 15 8.33333ZM10 8.33333C9.08334 8.33333 8.33334 9.08333 8.33334 9.99999C8.33334 10.9167 9.08334 11.6667 10 11.6667C10.9167 11.6667 11.6667 10.9167 11.6667 9.99999C11.6667 9.08333 10.9167 8.33333 10 8.33333Z",
    originalWidth: 20,
    originalHeight: 20,
    basicColor: "tableGray2",
    activeColor: "tableBlack2"
};
